<template>
  <span :class="getRatingNumber()"></span>
</template>
<script>

export default {
  name: 'Ratings',
  props: {
    rating: {
      default: 0
    }
  },
  methods: {
    getRatingNumber: function () {
      return `car-ratings-${Math.round(this.rating)}`;
    }
  }
}
</script>
